var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-layout-footer",
    [
      _c(
        "q-toolbar",
        {
          staticClass: "mobile-hide bg-primary",
          staticStyle: { padding: "0px", "min-height": "30px" }
        },
        [
          _c(
            "q-toolbar-title",
            { staticClass: "text-center text-weight-light" },
            [
              _c("small", [
                _vm._v(
                  "Copyright © " +
                    _vm._s(new Date().getFullYear()) +
                    ": " +
                    _vm._s(_vm.getProjectName) +
                    " v" +
                    _vm._s(_vm.getVersion) +
                    " - Powered by "
                ),
                _c(
                  "a",
                  {
                    staticClass: "text-white",
                    attrs: { href: "https://take5.com.br" }
                  },
                  [_vm._v("Take 5 LMS")]
                )
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }